module.exports = "https://cdn2-fs.clearscore.com/flux/images/7ffd4cb386db988bf1869977bde0705b.jpg";